module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-3-981197b60ba24bf677a670f93a9101f9.svg";